import _ from 'lodash';
import ko, { Computed, Observable, ObservableArray } from 'knockout';
import WorkItem from './WorkItem';
import { Field } from '../../../components/form/model';

export default class WorkQueue {
	items: ObservableArray<WorkItem>;
	count: Computed<number>;
	visible: Computed<number>;
	filterValue: Observable<string>;
	filterState: Observable<string>;

	constructor(data: any[], public stateField: Field, public hasActiveIndirect: boolean) {
		var queue = this;
		this.items = ko.observableArray([]);
		this.filterValue = ko.observable<string>(null);
		this.filterState = stateField.value;

		_.each(data, (n) => queue.items.push(new WorkItem(n, hasActiveIndirect)));

		this.filterValue.subscribe((v) => queue.filter(v, this.filterState()));
		this.filterState.subscribe((s) => queue.filter(this.filterValue(), s));

		this.count = ko.computed(() => this.items().length);

		this.visible = ko.computed(() => {
			return _.filter(queue.items(), (v: WorkItem) => v.visible()).length;
		});
	}

	filter(value: string, state: string) {
		var searchVal = (value || '').toLowerCase().trim();
		var searchState = (state || '').toLowerCase();

		_.each(this.items(), (v) => {
			var found =
				matchesState(v.state)
				&& (
					matchesValue(v.displayWorkOrder)
					|| _.some(v.fields, (field) => matchesValue(field.value))
				);

			v.visible(found);
		});

		function matchesValue(value: string): boolean {
			if (searchVal === '') return true;
			if (value === null || value === '') return false;

			return value.toLowerCase().indexOf(searchVal) >= 0;
		}

		function matchesState(value: string): boolean {
			if (searchState === '') return true;
			if (value === null) return false;

			return value.toLowerCase().indexOf(searchState) >= 0;
		}
	}
}
